const organizations = [
  "77LOGO",
  "testwithtransmit",
  "Demo",
  "Brandi Willms",
  "Patti Rowe",
  "Max Kautzer",
  "77LOGOt",
];

const campaignType = {
  1: 'Push Notification',
  2: 'Pop Ad',
  4: 'Banner Ad / Display Ad',
  5: 'Video Ad'
  // 6: 'Dynamic',
  // 7: 'HTML5',
  // 8: 'RichMedia',
  // 9: 'ConnectedTV',
  // 10: 'PDooH',
  // 1000: 'All',
}


const pricingModels = {
  1: 'CPC',
  2: 'CPM',
};

const goal = [
  "Sales",
  "Leads",
  "Awareness",
  "Acquisition",
  "App Installs",
  "Website Traffic",
];

const targetDays = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

const targetDevice = {
  0: 'Desktop',
  1: 'Mobile',
  2: 'Tablet',
  3: 'SmartTV',
};

const age = ["18-25", "26-35", "36-50", "51-70", "71-100"];

const gender = [
  "Male",
  "Female",
  "Trans-Gender",
  "Gender-Neutral",
  "Non-Binary",
];

const education = ["High School", "Bachelors", "Masters", "Doctorate"];

const connectionTypes = {
  0: 'WiFi',
  1: 'Cellular',
  2: 'Broadband',
  3: 'DialUp',
};

const interests = ["Technology", "Gaming", "Fashion", "Outdoor activities", "Fitness"]

const contexts = [
  "Content",
  "Social",
  "Shopping",
  "Search",
  "Video",
  "Gaming",
  "Music",
  "News",
  "Email",
  "Maps",
];

export {
  organizations,
  campaignType,
  pricingModels,
  goal,
  targetDays,
  targetDevice,
  age,
  contexts,
  gender,
  education,
  connectionTypes,
  interests,
};
